import React from 'react';
import About from '../components/About';

const AboutPage = () => {
  return (
    <main className="pt-32 md:pt-56 lg:pt-64">
      <div className="bg-[#04a6df] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-semibold text-white uppercase tracking-tight">
            Om Lene
          </h1>
          <p className="mt-4 text-white/90 text-lg max-w-2xl mx-auto">
            Lær mere om din kørelærer og min tilgang til undervisningen.
          </p>
        </div>
      </div>
      <About />
    </main>
  );
};

export default AboutPage;
